var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:(_vm.set + " " + _vm.set + "-" + _vm.iconName + " " + _vm.iconClass + " hnx-icon"),style:(_vm.style)},[_c('span',{ref:"iconName",staticClass:"hidden"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }